module.exports = __webpack_public_path__ + "static/headphones-product-sale-off-section-b57000ce5c2def3fff9ef7377a49de59.png";